export const FORECAST_COLUMNS_PER_PAGE = 12;
